<template>
	<div class="main-containter" id="top" v-title data-title="reservaion">
		<PHeader :checkId="'和华文化24'"  :activeNames="'和华文化'"></PHeader>
		
		<article>
			<div style="height:150px;width:100%">
				<img src="https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/otherTitle.png" style="height: 100%;width: 100%;">
				<div class="fbannerUpText" style="position: absolute;top: 120px;color: white;font-weight: 600;font-size: 20px;left: calc(50% - 40px);">和华文化</div>
				<div class="fbannerUpText" style="position: absolute;top: 155px;color: white;font-size: 14px;left: calc(50% - 31px);">Hehua Culture</div>
			</div>
			<div style="margin-top:10px;margin-left:3%;">
				<span style="color:#AAAAAA;font-size:14px;">首页 </span>
				<span style="color:#333333;font-size:14px;"> / 和华文化</span>
			</div>
			<div style="width:94%;margin-left:3%;margin-bottom:20px;">
				<div style="text-align: center;margin-top: 20px;">
					<a class="cultureType" @click="changeType('律师培养')" :style="{'background-color':type=='律师培养'?'#98273A':'white',color:type=='律师培养'?'white':'#98273A',padding:'5px 40px','font-size':'12px','border':'1px solid #98273A',cursor:'ponter'}">律师培养</a>
					<a class="cultureType" @click="changeType('团建活动')" :style="{'background-color':type=='团建活动'?'#98273A':'white',color:type=='团建活动'?'white':'#98273A',padding:'5px 40px','font-size':'12px','border':'1px solid #98273A'}">团建活动</a>
				</div>
				<div :style="{'padding-top':'30px','height':((tableList.length*110)+50)+'px'}">
					<div :style="{height:'100px','border-bottom':'1px solid #D7D7D7','margin-top':'20px'}" v-for="(item,index) in tableList" :key="index">
						<div style="float: left;height: 80px;width: 120px;">
							<img @click="toDetail(item)" style="width: 100%;height: 100%;" :src="item.image">
						</div>
						<div style="float: left;width: calc(85% - 150px);margin-left: 10px;padding-right: 10px;border-right: 1px solid rgb(215, 215, 215);overflow: hidden;text-overflow: ellipsis;">
							<a @click="toDetail(item)" class="cultureType" style="font-size: 16px;line-height: 30px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">{{item.title}}</a>
							<div @click="toDetail(item)" style="font-size: 12px;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;line-height: 24px;-webkit-box-orient: vertical;color: rgb(127, 127, 127);">{{item.description}}</div>
						</div>
						<div style="float: left;width: 10%;padding-left: 10px;text-align: center;">
							<div style="font-size: 14px;line-height: 50px;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;color: #7F7F7F;">{{item.publish.substring(0,4)}}</div>
							<div style="color: #7F7F7F;font-size: 12px;">{{item.publish.substring(5,10)}}</div>
						</div>
					</div>
				</div>
			</div>
			
			<el-pagination
				background
				layout="prev, pager, next"
				:page-size="5"
				:total="total"
				@current-change="handleCurrentChange">
			</el-pagination>
		</article>
		<Pooter></Pooter>
	</div>
</template>

<script>
	import PHeader from "../../components/p/PHeader.vue"
	import Pooter from "../../components/p/Pooter.vue"
	import {query} from "@/api/culture";
	export default {
		name: "Index",
		components: {
			PHeader,
			Pooter
		},
		data() {
			return {
				tableList: [],
				total:0,
				pageNo: 1,
				type:'律师培养'
			}
		},
		mounted() {
			this.list()
		},
		activated(){
			document.getElementById("top").scrollIntoView({ behavior: "smooth" });
		},
		methods: {
			changeType(type){
				this.type = type;
				this.pageNo = 1;
				this.list()
			},
			async toDetail(item,index){
				this.$router.push(
					{
						path:'/phone/hehuaCultureDetail',
						query:{
							id:item.id,
						}
					}
				);
			},
			handleCurrentChange(page){
				this.pageNo = page
				this.list()
			},
			list() {
				let param = {
					type: this.type,
					title: '',
					page: this.pageNo,
					pageSize: 5,
				}
				query(param).then(data => {
					this.tableList = data.data.list
					this.total = data.data.total
					// console.log("列表",this.tableData)
				}).catch(error => {
					this.$message.error(error)
				})
			},
		}
	}
</script>

<style lang="scss" scoped>
	.indexAboutUs{
		background: url("https://quantum-health.oss-cn-hangzhou.aliyuncs.com/lawyer/phoneBusiness.png") no-repeat;
		height:100%;
		width:100%;
		overflow: hidden;
		background-size:cover;//或者background-size:1
	}
	.main-containter {
		.news{
			background-image: url(../../assets/fImage/homeNewsBg.jpg);
			background-size: cover;
		}
	}
	.main-containter ::v-deep .el-carousel__indicators--horizontal{
		display: none;
	}

	.parentCarousel ::v-deep .el-carousel__container{
		height: 100%;
	}
	body ::v-deep .v-modal{
		display: none;
	}
div ::v-deep .el-pagination.is-background .btn-next:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div ::v-deep .el-pagination.is-background .btn-prev:disabled{
    margin: 0 5px;
    background-color: white !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
		color: #C3C3C7 !important;
}
div ::v-deep .el-pagination.is-background .btn-prev{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div ::v-deep .el-pagination.is-background .btn-next{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}
div ::v-deep .el-pagination.is-background .el-pager li{
    /*进行修改未选中背景和字体*/
    margin: 0 5px;
    background-color: white !important;
    color: #606266 !important;
    min-width: 30px;
    border-radius: 2px !important;
    font-weight: 400 !important;
    border: 1px solid #D9D9D9 !important;
}

div ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
  /*进行修改选中项背景和字体*/
	background-color: #98273A !important;
  color:white !important;
  border-radius: 2px !important;
  font-weight: 400 !important;
  border: 1px solid #98273A !important;
}

div ::v-deep .el-pagination.is-background .el-pager li:hover{
   color: #98273A !important;/*hover时候的文字颜色*/
 }
div ::v-deep .el-pager li.active{
   color:#98273A !important;/*仅设置active时的文字颜色*/
 }
div ::v-deep .el-pagination{
	text-align: center;
	margin-bottom: 20px;
}
</style>
